import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { ButtonLink } from '../ui/ButtonLink';
import { modules } from '../../data/modules';
import type { Workspace } from '../../types/content';
export function WorkspaceModules({
  workspace
}: {
  workspace: Workspace;
}) {
  const used = modules.filter(m => workspace.modules.includes(m.id));
  const unused = modules.filter(m => !workspace.modules.includes(m.id));
  return <section className="pb-20 md:pb-28" data-id="element-512" data-mp="1g1r4obmcv2i">
      <div className="mx-auto grid max-w-7xl gap-6 px-5 md:px-8 lg:grid-cols-[1.4fr_1fr]" data-id="element-513" data-mp="1f0bs7nklmez">
        <div className="glass rounded-[28px] p-7 md:p-9" data-id="element-514" data-mp="3sne8b3ci58if">
          <h2 className="text-2xl font-semibold tracking-tight md:text-3xl" data-id="element-515" data-mp="3okrbsp4vyzew">Modules in this workspace</h2>
          <p className="mt-2 text-[15px] text-ink-soft" data-id="element-516" data-mp="3jloexrz27zi0">
            Configured from Noetivra’s connected modules.{' '}
            <Link to="/how-it-works#modules" className="font-medium text-accent hover:text-accent-ink" data-id="element-517" data-mp="3em1vh0sn1n0r">
              How modules work
            </Link>
          </p>
          <ul className="mt-7 divide-y divide-ink/[0.07]" data-id="element-518" data-mp="1mjcni0r0so7q">
            {used.map(m => {
            const Icon = m.icon;
            return <li key={m.id} className="flex items-start gap-4 py-4" data-id="element-519" data-mp="1dlslgplc2nw2">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-accent-soft text-accent" data-id="element-520" data-mp="1ij2l0y2fsfxm">
                    <Icon className="h-4 w-4" aria-hidden="true" data-id="element-521" data-mp="26ahr91xc3he5" />
                  </span>
                  <div data-id="element-522" data-mp="2a9ql06sdjf9p">
                    <p className="font-semibold" data-id="element-523" data-mp="2a9yx3wgoagju">{m.name}</p>
                    <p className="mt-0.5 text-[15px] text-ink-soft" data-id="element-524" data-mp="1wbs7f3lvnmv9">{m.summary}</p>
                  </div>
                </li>;
          })}
          </ul>
          {unused.length ? <p className="mt-4 text-sm text-ink-muted" data-id="element-525" data-mp="kvkbhl0yb9sk">
              Not required here: {unused.map(m => m.name).join(', ')}.
            </p> : null}
        </div>

        <div className="flex flex-col rounded-[28px] bg-ink p-7 text-white md:p-9" data-id="element-526" data-mp="5skauukm6mxz">
          <p className="text-sm font-medium text-white/60" data-id="element-527" data-mp="5umxr5qgzzyh">Interactive demo · sample data</p>
          <h2 className="mt-2 text-2xl font-semibold tracking-tight" data-id="element-528" data-mp="1tkw6i92zbtc">{workspace.demo.name}</h2>
          <p className="mt-3 text-[15px] leading-relaxed text-white/75" data-id="element-529" data-mp="3t3rykr0sxe3q">{workspace.demo.tryText}</p>
          <a href={workspace.demo.url} target="_blank" rel="noopener noreferrer" className="group mt-auto inline-flex h-11 items-center justify-center gap-1.5 self-start rounded-full bg-white px-5 text-[15px] font-medium text-ink transition-colors duration-150 hover:bg-white/90" data-id="element-530" data-mp="3o4p2hw2sui7w">
            Open the demo
            <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:-translate-y-px group-hover:translate-x-px" aria-hidden="true" data-id="element-531" data-mp="3598r9ynqjx0r" />
            <span className="sr-only" data-id="element-532" data-mp="13gu3wk2fa0cy">(opens in a new tab)</span>
          </a>
          <div className="mt-6 hidden lg:block" data-id="element-533" data-mp="13eq2q9vwrfgd">
            <ButtonLink to="/demos" variant="quiet" className="text-white/70 hover:text-white" data-id="element-534" data-mp="1az22m9xtrekt">
              See all demos
            </ButtonLink>
          </div>
        </div>
      </div>
    </section>;
}